/* Copyright IBM Corp. 2018 */

export type AnyJson =  boolean | number | string | null | JsonArray | JsonMap;
export type JsonMap = object;
export interface JsonArray extends Array<AnyJson> {}

const _jsonParse = <T>(aValue: string): T => JSON.parse(aValue) as T;
const _jsonStringify = (aValue: AnyJson): string => JSON.stringify(aValue);

export {
    _jsonParse as jsonParse,
    _jsonStringify as jsonStringify
};
